import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';
import type { Customer } from './types';

export type UpdateCustomerResponse = Customer;
type Variables = {
  currentPassword?: string;
  newPassword?: string;
};

export const useCustomerUpdatePassword = createMutation<
  UpdateCustomerResponse,
  Variables,
  AxiosError
>({
  mutationFn: async ({ currentPassword, newPassword }) =>
    client({
      url: 'v2/customers/me/password',
      method: 'PUT',
      data: {
        current_password: currentPassword,
        new_password: newPassword,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
